import type { ElementType, FC, Ref } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { Flex, type FlexProps } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { sectionStyle } from "./Section.css";

export type SectionProps = FlexProps &
  RecipeVariants<typeof sectionStyle> & {
    as?: ElementType;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

export const Section: FC<SectionProps> = ({
  as = "section",
  variant = "default",
  direction = "column",
  shrink = false,
  edge,
  edgePosition,
  overflowVisible,
  className,
  ref,
  ...props
}) => (
  <Flex
    as={as}
    ref={ref}
    className={mergeClasses(
      sectionStyle({
        variant,
        edge,
        edgePosition: edge ? (edgePosition ?? "bottom") : undefined,
        overflowVisible,
      }),
      className,
    )}
    direction={direction}
    data-section={variant}
    shrink={shrink}
    {...props}
  />
);
